import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { FaMediumM, FaCalendarAlt, FaArrowRight, FaPenFancy } from 'react-icons/fa'
import { fetchMediumPosts } from '../../data/mediumData'
import SectionHeading from '../shared/SectionHeading'
import './Blog.css'

const BlogCard = ({ post }) => {
  return (
    <motion.a
      className="blog-card"
      href={post.link}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.5 }}
      whileHover={{ y: -5 }}
    >
      {post.thumbnail ? (
        <img
          className="blog-card__image"
          src={post.thumbnail}
          alt={post.title}
          loading="lazy"
        />
      ) : (
        <div className="blog-card__image-placeholder">
          <FaPenFancy />
        </div>
      )}
      <div className="blog-card__body">
        <h3 className="blog-card__title">{post.title}</h3>
        <p className="blog-card__description">{post.description}</p>
        <div className="blog-card__meta">
          <span className="blog-card__date">
            <FaCalendarAlt /> {post.pubDate}
          </span>
          <span className="blog-card__readmore">
            Read More <FaArrowRight />
          </span>
        </div>
      </div>
    </motion.a>
  )
}

const Blog = () => {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const loadPosts = async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await fetchMediumPosts('@pasinduperera10', 3)
      if (data.length === 0) {
        setError('No blog posts found yet.')
      } else {
        setPosts(data)
      }
    } catch (err) {
      setError('Failed to load blog posts.')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadPosts()
  }, [])

  return (
    <section className="blog-container" id="blog">
      <SectionHeading icon={<FaMediumM />}>Latest Blog Posts</SectionHeading>

      {loading && (
        <div className="blog-loading">
          <div className="blog-loading__spinner" />
          <p>Loading latest posts from Medium...</p>
        </div>
      )}

      {error && !loading && (
        <div className="blog-no-posts">
          <p>{error}</p>
          <p>
            Check out{' '}
            <a
              href="https://medium.com/@pasinduperera10"
              target="_blank"
              rel="noopener noreferrer"
            >
              my Medium profile
            </a>{' '}
            for latest articles.
          </p>
        </div>
      )}

      {!loading && !error && (
        <motion.div
          className="blog-content"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.6, staggerChildren: 0.1 }}
        >
          {posts.map((post, i) => (
            <BlogCard key={i} post={post} />
          ))}
        </motion.div>
      )}
    </section>
  )
}

export default Blog